import React, { useContext, useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import { api } from "../../../services/api";
import { useHistory, useParams} from "react-router-dom/cjs/react-router-dom.min";
import { PaginatorContext } from "../../../providers/Paginator";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { Button, Container, Table, TablePagination, TableBody, Paper, TableContainer, TableHead, TableRow, TableCell, CircularProgress, Chip, TextField, InputAdornment, Alert, Box } from "@mui/material";
import { Search as SearchIcon, Close as CloseIcon, } from "@mui/icons-material";
import moment from "moment";
import withAuthenticationRequired from "../../../components/ProtectedRoutes/withAuthenticationRequired";

export const VentasCaja = () => {
  const history = useHistory();
  const param = useParams();
  const [loading, setLoading] = useState(false);

  const {
    query,
    setQuery,
    totalLength,
    setTotalLength,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
  } = useContext(PaginatorContext);

  const [ventas, setVentas] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    const callApi = async (id) => {
      setLoading(true);

      try {
        const response = await api.ventas.getVentasCaja(
          id,
          query,
          pageSize,
          currentPage
        );

        if (response.status === "success") {
          setVentas(response.data.ventas_caja || []);
          setTotalLength(response.data.totalDataSize || 0);
        }
      } catch (error) {
        toast.error(error.message, {
          position: "top-center",
          autoClose: 4000,
        });
      } finally {
        setLoading(false);
      }
    };

    callApi(param.id);
  }, [param.id, query, pageSize, currentPage, setTotalLength]);

  useEffect(() => {
  // reset pagina si cambia la query
  if (query.length > 0) {
    setCurrentPage(0);
  }
}, [query, setCurrentPage]);

const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(0);
};

  // cambio de pagina
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  // tama;o de pagina
  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  /* const handleRowClick = (venta) => {
    // si la venta esta aprobada y finalizada, se puede redirigir
    if (venta.estado === 'APROBADO') {
      history.push(`/eventos/${param.id}/ventas/${venta.compra_id}`);
    }
  }; */

  const handleToggleSearch = () => {
    setShowSearch(!showSearch);
    setQuery("");
  };

  // chip del estado de la venta
  const getEstadoChip = (estado) => {
    switch (estado) {
      case 'APROBADO':
        return <Chip label="Aprobado" color="success" size="small" />;
      case 'PENDIENTE':
        return <Chip label="Pendiente" color="warning" size="small" />;
      default:
        return <Chip label={estado} color="default" size="small" />;
    }
  };

  // chip medio pago
  const getMedioPagoChip = (medioPago) => {
    switch (medioPago) {
      case 'efectivo':
        return <Chip label="Efectivo" color="success" variant="outlined" size="small" />;
      case 'qr-pvs':
        return <Chip label="QR PVS" color="primary" variant="outlined" size="small" />;
      case 'qr-clickmacro':
        return <Chip label="QR ClickMacro" color="secondary" variant="outlined" size="small" />;
      case 'qr-pagotic':
        return <Chip label="QR Pagotic" color="info" variant="outlined" size="small" />;
      default:
        return <Chip label={medioPago} color="default" variant="outlined" size="small" />;
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        {showSearch ? (
          <Box sx={{ display: 'flex', gap: 1, width: { xs: '100%', sm: '50%' } }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Buscar por ID, referencia..."
              value={query}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Button 
              variant="outlined" 
              onClick={() => setShowSearch(false)}
              sx={{ minWidth: 'auto', px: 2 }}
            >
              <CloseIcon />
            </Button>
          </Box>
        ) : (
          <Button 
            variant="contained" 
            onClick={handleToggleSearch}
            startIcon={<SearchIcon />}
          >
            Buscar
          </Button>
        )}
      </Box>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>ID Compra</strong></TableCell>
              <TableCell><strong>Fecha</strong></TableCell>
              <TableCell align="center"><strong>Tarifas</strong></TableCell>
              <TableCell align="center"><strong>Cantidad</strong></TableCell>
              <TableCell align="center"><strong>Medio de Pago</strong></TableCell>
              <TableCell align="center"><strong>Estado</strong></TableCell>
              <TableCell align="center"><strong>Total</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : (
              ventas && ventas.length > 0 ? (
                ventas.map((venta) => (
                  <TableRow
                    key={venta.compra_id}
                    /* onClick={venta.estado === 'APROBADO' ? () => handleRowClick(venta) : undefined}
                    sx={{ 
                      cursor: venta.estado === 'APROBADO' ? "pointer" : "default",
                      '&:hover': venta.estado === 'APROBADO' ? { backgroundColor: '#f5f5f5' } : {}
                    }} */
                  >
                    <TableCell>
                      <strong>{venta.compra_id}</strong>
                    </TableCell>

                    <TableCell>
                      {moment.parseZone(venta.fecha_venta).format("DD/MM/YYYY HH:mm")}
                    </TableCell>

                    <TableCell align="center">
                      <Box sx={{ maxWidth: 200, wordWrap: 'break-word' }}>
                        {venta.tarifas}
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      <strong>{venta.cantidad_tickets}</strong>
                    </TableCell>

                    <TableCell align="center">
                      {getMedioPagoChip(venta.medio_pago)}
                    </TableCell>

                    <TableCell align="center">
                      {getEstadoChip(venta.estado)}
                    </TableCell>

                    <TableCell align="center">
                      <strong style={{ color: '#2e7d32' }}>
                        ${venta.total?.toFixed(2) || '0.00'}
                      </strong>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} sx={{ py: 4 }}>
                    <Alert severity="info" sx={{ textAlign: 'center' }}>
                      No tienes ventas de caja registradas
                    </Alert>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 25, 50]}
          count={totalLength}
          rowsPerPage={pageSize}
          page={currentPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Filas por página:"
          showFirstButton
          showLastButton
        />
      </TableContainer>
    </Container>
  );
};

export default withAuthenticationRequired(VentasCaja, {
  onRedirecting: () => <Loading />,
});